import { accessRole } from "../../../../../helpers/access_role"
import { config } from "../../../../../helpers/config_global"
import React, { useState, Component, Fragment } from "react"
import { Redirect } from "react-router-dom"

import { Tooltip, Alert } from "reactstrap"

import MKIDatatable from '../../../../../modules/mki-datatable/lib'
import { ConfirmAlert } from '../../../../../helpers/ui/alert'

import { cancelToken } from "../../../../../services/adapters/kepegawaian/verificationService"

import DataTableBloc from '../Blocs/DataTableBloc'
import IndexBloc from "../Blocs/IndexBloc"
import apiResponse from '../../../../../services/apiResponse'

import moment from "moment"

class TableProcessComponent extends Component {Component
    dataTableBloc = new DataTableBloc();
    indexBloc = new IndexBloc();
    
    userdata = JSON.parse(localStorage.getItem('userdata'));
    employeeSeleted = JSON.parse(localStorage.getItem('employeeSelected'))
    peg_detail = !accessRole('approve') ? (this.userdata != null ? this.userdata : "") 
    : (this.employeeSeleted != null ? this.employeeSeleted : "")

    source
    historyTable = 'historyTableHDProcess'
    defaultOrder = 'punishment_discipline_id'
    defaultSize = 10
    defaultSort = 'desc'
    configDatatable = {
        ...config('datatable'),
        sort: {
            column: this.defaultOrder,
            order: this.defaultSort
        }
    }

    constructor(props) {
        super(props)
        this.state = {
            tooltip: false,
            detailUuid: null,
            uploadSkUuid: null,
            uploadHasilUuid: null,
            updateUuid: null,
            inactiveUuid: null,
            defaultSize: 10,
            rows: [],
            totalRow: 0,
            loadingTable: true,
            filter: sessionStorage.getItem(this.historyTable) ?
                JSON.parse(sessionStorage.getItem(this.historyTable)) :
                {
                    filter_value: "",
                    page_number: 1,
                    page_size: this.defaultSize,
                    sort_order: {
                        column: this.defaultOrder,
                        order: this.defaultSort
                    }
                },
            isAtasan: this.userdata?.is_atasan
        }
    }
    toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });

    loadData = async () => {
        /* history Datatable */
        sessionStorage.setItem(this.historyTable, JSON.stringify(this.state.filter))

        let additionalFilter = this.props.additionalFilter;

        /* kirim ke server */
        let offset = (this.state.filter.page_number-1)*this.state.filter.page_size
        if(this.state.defaultSize!==this.state.filter.page_size) {
            this.setState({
                defaultSize: this.state.filter.page_size
            })
            offset = 0
            this.configDatatable.page_number = 1
        }
        const query = {
            search: this.state.filter.filter_value,
            limit: this.state.filter.page_size,
            offset: offset,
            order: this.state.filter.sort_order.column,
            sort: this.state.filter.sort_order.order,
            status: 1,
            is_atasan: this.state.isAtasan,
            work_unit_uuid: this.peg_detail.employee_current_work_unit_uuid,
            employee_uuid: this.peg_detail.employee_uuid,
            ...additionalFilter
        }
        await this.dataTableBloc.fetchRowTable(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadData()
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                //this.inactiveData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }
    
    inactiveData = async () => {
        //await this.dataTableBloc.fetchInactive({ uuid: this.state.inactiveUuid })
    }

    componentDidMount() {
        this.setTokenAPI()

        this.dataTableBloc.rowtableChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        loadingTable: false
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        loadingTable: true
                    })
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    this.setState({
                        totalRow: response.total,
                        rows: response.result,
                        loadingTable: false
                    })
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
    }

    componentWillUnmount() {
        this.dataTableBloc.rowtableChannel.unsubscribe()
    }

    columns = [
        {
            key: "punishment_discipline_employee_nip",
            text: "NIP",
            className: "punishment_discipline_employee_nip",
            sortable: true,
            width: '130'
        },
        {
            key: "punishment_discipline_employee_name",
            text: "Nama",
            className: "punishment_discipline_employee_name",
            sortable: true
        },
        {
            key: "punishment_discipline_employee_work_unit",
            text: "Unit Kerja",
            className: "punishment_discipline_employee_work_unit",
            sortable: true,
            width: '200'
        },
        {
            key: "punishment_discipline_period_year",
            text: "Tahun",
            className: "punishment_discipline_period_year",
            sortable: true,
            width: '200'
        },
        {
            key: "punishment_discipline_total_day_late",
            text: "Akumulasi Hari",
            className: "punishment_discipline_total_day_late",
            sortable: true,
            width: '200',
            cell : record => {
                return record.punishment_discipline_total_day_late + ' Hari';
            }
        },
        {
            key: "punishment_discipline_punishment_name",
            text: "Rekomendasi Hukuman Disiplin",
            className: "punishment_discipline_punishment_name",
            sortable: true,
            width: '200'
        },
        {
            key: "punishment_discipline_result_punishment_name",
            text: "Keputusan Hukuman Disiplin",
            className: "punishment_discipline_result_punishment_name",
            sortable: true,
            width: '200'
        },
        {
            key: "punishment_discipline_result_final_punishment_name",
            text: "Hasil Akhir Hukuman Disiplin",
            className: "punishment_discipline_result_final_punishment_name",
            sortable: true,
            width: '200'
        },
        {
            key: "punishment_discipline_status_name",
            text: "Status",
            className: "punishment_discipline_status_name",
            sortable: true,
            width: '200'
        },
        {
            key: "action",
            text: "Action",
            className: "action",
            width: 120,
            sortable: false,
            align: 'center',
            cell: record => {
                const thisId = record.punishment_discipline_id
                var  status = record.punishment_discipline_status
                return (
                    <Fragment>
                        { accessRole('read') && status == 1 &&
                            <span>
                                <button
                                    className="btn btn-primary btn-sm"
                                    id={"detail-" + thisId}
                                    onClick={() => {
                                        this.setState({
                                            detailUuid: record.punishment_discipline_uuid
                                        })
                                    }}
                                    style={{
                                        marginRight: '2px',
                                        padding: '2px 5px'
                                    }}>
                                        <i className="uil-align-left"></i>
                                </button>
                                <Tooltip
                                    style={{
                                        marginBottom: 2
                                    }}
                                    placement="top" isOpen={this.state["detail" + thisId]} target={"detail-" + thisId}
                                    toggle={() => {
                                        this.setState({
                                            ["detail" + thisId] : !this.state["detail" + thisId]
                                        })
                                    }}
                                >Detail</Tooltip>
                            </span>
                        }

                        {
                          status == -1 && this.state.isAtasan == 1 ?
                            <>
                                <span>
                                    <button
                                        className="btn btn-warning btn-sm"
                                        id={"uploadHasil-" + thisId}
                                        onClick={() => {
                                            this.setState({
                                                uploadHasilUuid: record.punishment_discipline_uuid
                                            })
                                        }}
                                        style={{
                                            marginRight: '2px',
                                            padding: '2px 5px'
                                        }}>
                                            <i className="uil-file-upload-alt"></i>
                                    </button>
                                    <Tooltip
                                        style={{
                                            marginBottom: 2
                                        }}
                                        placement="top" isOpen={this.state["uploadHasil" + thisId]} target={"uploadHasil-" + thisId}
                                        toggle={() => {
                                            this.setState({
                                                ["uploadHasil" + thisId] : !this.state["uploadHasil" + thisId]
                                            })
                                        }}
                                    >Input Hasil Pemeriksaan</Tooltip>
                                </span>
                            </>
                            : ""
                        }

                        {/* {
                          status == 0 && this.state.isAtasan == 1 ?
                            <>
                                <span>
                                    <button
                                        className="btn btn-warning btn-sm"
                                        id={"uploadSk-" + thisId}
                                        onClick={() => {
                                            this.setState({
                                                uploadSkUuid: record.punishment_discipline_uuid
                                            })
                                        }}
                                        style={{
                                            marginRight: '2px',
                                            padding: '2px 5px'
                                        }}>
                                            <i className="uil-file-upload-alt"></i>
                                    </button>
                                    <Tooltip
                                        style={{
                                            marginBottom: 2
                                        }}
                                        placement="top" isOpen={this.state["uploadSk" + thisId]} target={"uploadSk-" + thisId}
                                        toggle={() => {
                                            this.setState({
                                                ["uploadSk" + thisId] : !this.state["uploadSk" + thisId]
                                            })
                                        }}
                                    >Upload SK</Tooltip>
                                </span>
                            </>
                            : ""
                        } */}

                    </Fragment>
                );
            }
        }        
    ]

    render() {
        return (
            <>
                <MKIDatatable
                    className={this.configDatatable.tableClass}
                    config={this.configDatatable}
                    records={this.state.rows}
                    columns={this.columns}
                    dynamic={true}
                    minWidth={1000}
                    total_record={this.state.totalRow}
                    initial={this.state.filter}
                    onChange={(filter) => {
                        this.setState({
                            loadingTable: true,
                            filter: filter
                        }, function () {
                            this.setTokenAPI()
                        });
                    }}
                    loading={this.state.loadingTable}
                />
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menghapus data ini?"

                    loadingTitle="Memproses data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil dihapus"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal dihapus"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.detailUuid !== null ?
                    // <Redirect to={"/sample.html?detail&uuid=" + this.state.detailUuid}/>
                    <Redirect to={"/kepegawaian/hukuman_disiplin.html?detail&uuid="+ this.state.detailUuid}/>
                : null }
                { this.state.uploadHasilUuid !== null ?
                    <Redirect to={"/kepegawaian/hukuman_disiplin.html?upload_hasil&uuid="+ this.state.uploadHasilUuid}/>
                : null }
                { this.state.uploadSkUuid !== null ?
                    <Redirect to={"/kepegawaian/hukuman_disiplin.html?upload_sk&uuid="+ this.state.uploadSkUuid}/>
                : null }
            </>
        )
    }

}

export default TableProcessComponent